// extracted by mini-css-extract-plugin
module.exports = {"countrySelector":"CountrySelector_countrySelector__3Bi_a","flag":"CountrySelector_flag__2ufj-","countryName":"CountrySelector_countryName__2z5zS"};